import { render, staticRenderFns } from "./ModifyInterfaces.vue?vue&type=template&id=a92d8142&scoped=true&"
import script from "./ModifyInterfaces.vue?vue&type=script&lang=ts&"
export * from "./ModifyInterfaces.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92d8142",
  null
  
)

export default component.exports